<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="TableLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedPersons"
		dataKey="TableID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--ID-->
				<th>
					<p-columnFilter type="text" field="ID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolFullName-->
				<th>
					<p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AppDesc-->
				<th>
					<p-columnFilter field="AppDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAppDesc
								[ngModel]="value"
								[options]="lstAppDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ValidEntryDesc-->
				<th>
					<p-columnFilter field="ValidEntryDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterValidEntryDesc
								[ngModel]="value"
								[options]="lstValidEntryDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ProgressDesc-->
				<th>
					<p-columnFilter field="ProgressDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterProgressDesc
								[ngModel]="value"
								[options]="lstProgressDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="ID">ID<p-sortIcon field="ID"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="SchoolFullName">School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
				<th pSortableColumn="AppDesc">App<p-sortIcon field="AppDesc"></p-sortIcon></th>
				<th pSortableColumn="ValidEntryDesc">Valid Entry<p-sortIcon field="ValidEntryDesc"></p-sortIcon></th>
				<th pSortableColumn="ProgressDesc">Progress<p-sortIcon field="ProgressDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td>
					<p-tableCheckbox [disabled]="TableLoading == true" [pSelectableRow]="Person" [value]="Person"></p-tableCheckbox>
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">{{ Person.ID }}</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">{{ Person.FirstName }}</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">{{ Person.LastName }}</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">{{ Person.SchoolFullName }}</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Person.Active == true ? 'Black' : 'Red'">
					{{ Person.ActiveDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<input *ngIf="Person.ValidEntry == true" type="text" class="form-control" [(ngModel)]="Person.Email" />
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">{{ Person.AppDesc }}</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Person.ValidEntry == true ? 'Black' : 'Red'">
					{{ Person.ValidEntryDesc }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">{{ Person.ProgressDesc }}</td>
			</tr>
		</ng-template>
	</p-table>
</div>
